import {
  Box,
  Button,
  Collapse,
  HStack,
  IconButton,
  Progress,
  Select,
  useBoolean,
  VStack,
} from "@chakra-ui/react";
import Historic from "components/generic/Historic";
import { isUnauthorized } from "helpers/errors";
import { useGlobals } from "hooks/helpers/useGlobals";
import { OperationModel, OperationStatusEnum } from "interfaces/operation";
import {
  ExcelStatusEnum,
  OperationExcelModel,
} from "interfaces/operation_excel";
import { UserTypeEnum } from "interfaces/user";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { BiHistory, BiShow } from "react-icons/bi";

import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  clearGlobalMessage,
  clearLoading,
  setGlobalMessage,
  showLoading,
} from "redux/actions";
import CardPage from "v2/components/pages/CardPage";
import { Col } from "v2/components/shared/Col";
import SimpleFormGenerator from "v2/components/shared/SimpleFormGenerator";

import { useCurrencyQuery } from "v2/hooks/api/currency/useCurrencyQuery";
import { useHashData } from "v2/hooks/helpers/useHashData";
import { createCurrencySearchPicker } from "v2/services/app/factories/forms/createCurrencySearchPicker";
import { createCustomerSearchPicker } from "v2/services/app/factories/forms/createCustomerSearchPicker";
import { createPayerReceiverSearchPicker } from "v2/services/app/factories/forms/createPayerReceiverSearchPicker";
import { apiClient } from "v2/services/clients/apiClient";
import DataTable, { TableColumn } from "react-data-table-component";
import {
  capitalizeFirstLetter,
  formatCNPJ,
  formatDate,
  formatProduct,
} from "helpers/formats";
import { getMoeda } from "helpers/moedas";
import AppContext from "hooks/helpers/useLastFilter";
import { Permissions } from "interfaces/web/permission";
import styled from "styled-components";
import { ExcelExportXlsx } from "services/ExcelExportXlsx";
import { createClientSearchPicker } from "v2/services/app/factories/forms/createClientSearchPicker";
import { createClientForGroupSearchPicker } from "v2/services/app/factories/forms/createClientForGroupSearchPicker";
import { Row } from "v2/components/shared/Row";
import { RiFileExcel2Line } from "react-icons/ri";
import { FaFileDownload, FaRegTrashAlt, FaSearch } from "react-icons/fa";
import { filterCompany, filterGroup } from "v2/services/helpers/filters";

const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const FilterComponent = ({ filterText, onFilter, onType }: any) => (
  <>
    <Select mr={3} onChange={onType} size="sm" w={"180px"}>
      <option value={1}>ID</option>
      <option value={2}>Usuário</option>
      <option value={3}>Referência</option>
    </Select>
    <TextField
      id="search"
      type="text"
      placeholder="Buscar"
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
    />
  </>
);

const ListOperationsPage: React.FC = () => {
  const { user, isDascam, isAutorizado, hasPermissions } = useGlobals();

  const permCreation = isAutorizado
    ? !hasPermissions([Permissions.PROCESS_CREATE])
    : false;
  const permDelete = isAutorizado
    ? hasPermissions([Permissions.PROCESS_CREATE])
    : true;
  const permEdit = isAutorizado
    ? hasPermissions([Permissions.PROCESS_EDIT, Permissions.PROCESS_VIEW])
    : true;
  const permView = isAutorizado
    ? hasPermissions([Permissions.PROCESS_VIEW])
    : true;

  const date = new Date().toISOString().split("T")[0];
  const Default = AppContext?.operations
    ? AppContext?.operations
    : user.cad_type === UserTypeEnum.DASCAM
    ? {
        start_date: date,
        end_date: date,
        status: "SENT",
        mode: "two",
      }
    : {
        start_date: date,
        end_date: date,
        mode: "two",
      };

  const [filterTextExternal, setFilterTextExternal] =
    React.useState<string>("");
  const [filterTextType, setFilterTextType] = React.useState<number>(1);
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <FilterComponent
        filterText={filterTextExternal}
        onFilter={(e: any) => {
          setFilterTextExternal(e.target.value);
        }}
        onType={(e: any) => {
          setFilterTextType(Number(e.target.value));
        }}
      />
    );
  }, [filterTextExternal]);

  useEffect(() => {
    redirect(hashData);
    if (hashData.mode === "one") {
      setMode("one");
      loadProcess();
    } else {
      setMode("two");
      loadExcel();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dispatch = useDispatch();
  const history = useHistory();
  const { hashData, redirect } = useHashData(Default);
  const [isLoading, loading] = useBoolean();
  const { data: currencies } = useCurrencyQuery();
  const [operations, setOperations] = useState<OperationModel[]>([]);
  const [spreadsheets, setSpreadsheets] = useState<OperationExcelModel[]>([]);
  const [spreadsheetsFiles, setSpreadsheetsFiles] = useState<
    OperationExcelModel[]
  >([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [reload, setReload] = useState<boolean>(true);
  const [operation, setOperation] = useState<OperationModel>(
    {} as OperationModel
  );
  const [groupList, setGroupList] = useState<any[]>([]);
  const [mode, setMode] = useState<"one" | "two">("one");

  const [progress, setProgress] = useState(0);
  const [downloadedMB, setDownloadedMB] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    redirect(hashData);
    if (hashData.mode === "one") {
      setMode("one");
      loadProcess();
    } else {
      setMode("two");
      loadExcel();
    }
  }, []);

  const filterAPI = useMemo(() => {
    if (!hashData) return undefined;

    const { start_date, end_date, status, id } = hashData;

    const isDascam = user.cad_type === UserTypeEnum.DASCAM;
    let id_syscambio;

    const group_id = !hashData.group?.id_syscambio
      ? hashData.customer?.group_id
      : undefined;

    if (isDascam) {
      id_syscambio =
        hashData.group?.id_syscambio || hashData.customer?.id_syscambio;
    } else if (user.cad_type === "AUTORIZADO") {
      if (user.permission_group_company) {
        if (user.permission_group_company.includes(Number(user.id_syscambio))) {
        } else {
          if (hashData.customer?.id_syscambio) {
            id_syscambio = hashData.customer?.id_syscambio || null;
          } else {
            return undefined;
          }
        }
      } else {
        if (hashData.customer?.id_syscambio) {
          id_syscambio = hashData.customer?.id_syscambio || null;
        } else {
          return undefined;
        }
      }
    } else {
      id_syscambio =
        hashData.group?.id_syscambio || hashData.customer?.id_syscambio;
    }
    return {
      client_name: hashData.customer?.fantasy_name,
      id_syscambio: id_syscambio,
      date: start_date && end_date ? [start_date, end_date] : undefined,
      status: status ? [status] : undefined,
      product_type: hashData.operation_type,
      currency_name: hashData.currency_code?.Nome,
      group: group_id,
      limit: 2000,
      offset: 0,
      id: id ? Number(id) : undefined,
    };
  }, [hashData, user]);

  const columnsOperationExcel: TableColumn<OperationExcelModel>[] = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "65px",
    },
    {
      name: "Usuário",
      selector: (row) => row.user?.user_name || "---",
      sortable: true,
      width: "265px",
    },
    {
      name: "Empresa",
      selector: (row) => row.client_name || "---",
      sortable: true,
    },
    {
      name: "Referência/PO",
      selector: (row) => row.client_ref || "---",
      sortable: true,
    },
    {
      name: "Data de Lançamento",
      selector: (row) =>
        row.created_date
          ? new Date(row.created_date)
              ?.toLocaleString("pt-BR", { timeZone: "UTC" })
              .split(",")[0]
          : "---",
      sortable: true,
      width: "180px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.status ? ExcelStatusEnum.format(row.status) : "---",
      width: "160px",
    },
    {
      name: "AÇÕES",
      cell: (row) => action(row),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  const columns: TableColumn<OperationModel>[] = [
    {
      name: "Ações",
      cell: (row) => (
        <HStack m={1}>
          {permEdit &&
            (row.status === OperationStatusEnum.PENDING ||
              row.status === OperationStatusEnum.CORRECTION) && (
              <Link to={`/operations/edit/${row.id}`} title="Editar">
                <IconButton
                  aria-label="Editar"
                  size={"sm"}
                  colorScheme={"secondary"}
                  color={"primary.400"}
                >
                  <AiOutlineEdit size={16} />
                </IconButton>
              </Link>
            )}
          {permView && (
            <Link to={`/operations/show/${row.id}`} title="Visualizar">
              <IconButton
                aria-label="Visualizar"
                size={"sm"}
                colorScheme={"blue"}
              >
                {!isDascam ? <BiShow size={16} /> : <AiOutlineEdit size={16} />}
              </IconButton>
            </Link>
          )}
          {permDelete &&
            (row.status === OperationStatusEnum.PENDING ||
              row.status === OperationStatusEnum.CORRECTION) && (
              <IconButton
                aria-label="Deletar"
                title="Excluir"
                size={"sm"}
                colorScheme={"red"}
                onClick={() => {
                  if (
                    row.status === OperationStatusEnum.PENDING ||
                    row.status === OperationStatusEnum.CORRECTION
                  ) {
                    handleDeleteItem(row.id ?? 0);
                  } else {
                    handleDeleteOperation(row.id ?? 0);
                  }
                }}
              >
                <AiOutlineDelete size={16} />
              </IconButton>
            )}
          <IconButton
            aria-label="Histórico"
            title="Histórico"
            size={"sm"}
            onClick={() => {
              setShowModal(!showModal);
              setOperation(row);
            }}
            colorScheme={"primary"}
          >
            <BiHistory size={16} />
          </IconButton>
        </HStack>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },
    {
      name: "ID",
      selector: (row) => row.id ?? "",
      sortable: true,
      width: "65px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.status ? OperationStatusEnum.format(row.status) : "---",
      width: "100px",
    },
    {
      name: "Tipo de Contrato",
      selector: (row) => formatProduct(row.product_type ?? ""),
      sortable: true,
      width: "160px",
    },
    {
      name: "Cliente",
      selector: (row) => row.client_name ?? "---",
      sortable: true,
      width: "260px",
    },
    {
      name: "Data de Lançamento",
      selector: (row) =>
        row.created_date
          ? new Date(row.created_date)
              .toLocaleString("pt-BR", {
                timeZone: "UTC",
              })
              .replace(",", "")
          : "",
      sortable: true,
      width: "170px",
    },
    {
      name: "Pagador/Recebedor",
      selector: (row) => row.beneficiary_name ?? "",
      width: "300px",
    },
    {
      name: "Moeda",
      selector: (row) => getMoeda(Number(row.currency_code ?? 0)) ?? "",
      minWidth: "80px",
    },
    {
      name: "Valor",
      selector: (row) =>
        Number(row.process_value)?.toLocaleString("pt-br", {
          minimumFractionDigits: 2,
        }),
      width: "150px",
      right: true,
    },
    {
      name: "Usuário",
      selector: (row) => row.user?.user_name ?? "---",
      sortable: true,
      width: "265px",
    },
    {
      name: "Referência",
      selector: (row) => row.ref_cli ?? "---",
      sortable: true,
      width: "260px",
    },
  ];

  const exportMode2Excel = async () => {
    const rows = spreadsheets.map((o) => {
      return {
        ID: o.id,
        Usuário: o.user?.user_name || "---",
        Empresa: o.client_name || "---",
        Referência: o.client_ref || "---",
        "Data de Lançamento": formatDate(o.created_date?.toString() ?? ""),
        Status: capitalizeFirstLetter(ExcelStatusEnum.format(o.status!)),
      };
    });

    let objectMaxLength: any[] = [];
    for (let i = 0; i < rows.length; i++) {
      let value: any = Object.values(rows[i]);
      for (let j = 0; j < value.length; j++) {
        if (typeof value[j] == "number") {
          objectMaxLength[j] = 15;
        } else {
          objectMaxLength[j] =
            objectMaxLength[j] >= value[j]?.length
              ? objectMaxLength[j]
              : value[j]?.length >= 15
              ? value[j]?.length + 1
              : 15;
        }
      }
    }

    await ExcelExportXlsx.fromJSON(
      "exportacao",
      rows,
      [
        { width: Number(objectMaxLength[0]) },
        { width: Number(objectMaxLength[1]) },
        { width: Number(objectMaxLength[2]) },
        { width: Number(objectMaxLength[3]) },
        { width: Number(objectMaxLength[4]) },
      ],
      []
    );
  };
  async function exportFilesExcel() {
    try {
      setIsDownloading(true);
      setProgress(0);
      setDownloadedMB(0);
      loading.on();

      const response = await apiClient.operations.zipDownloadSpreadSheets(
        spreadsheetsFiles.map((e) => ({
          url: e.attachment,
          name: `${e.id} s${e.client_name}`,
        }))
      );

      if (!response.body) throw new Error("Streaming não suportado");

      const total = Number(response.headers.get("Content-Length"));

      console.log("Tamanho total do arquivo:", total, "bytes");

      const hasLength = !isNaN(total) && total > 0;

      const reader = response.body.getReader();

      let received = 0;

      const chunks: BlobPart[] = [];

      while (true) {
        const { done, value } = await reader.read();

        if (done) break;

        if (value) {
          chunks.push(
            value.buffer.slice(
              value.byteOffset,
              value.byteOffset + value.byteLength
            )
          );

          received += value.length;

          setDownloadedMB(received / 1024 / 1024);

          if (hasLength) {
            setProgress((received / total) * 100);
          }
        }
      }

      const blob = new Blob(chunks, {
        type: "application/zip",
      });

      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `exportacao-${Date.now()}.zip`;
      a.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setIsDownloading(false);
      loading.off();
    }
  }
  function action(data: any) {
    return (
      <HStack m={1}>
        <Link to={`/spreadsheets/show/${data.id}`} title="Visualizar">
          <IconButton
            disabled={!permView}
            aria-label="Visualizar"
            size={"sm"}
            colorScheme={"blue"}
          >
            {!isDascam ? <BiShow size={16} /> : <AiOutlineEdit size={16} />}
          </IconButton>
        </Link>
        {!isDascam &&
          permEdit &&
          (data.status === OperationStatusEnum.PENDING ||
            data.status === OperationStatusEnum.CORRECTION) && (
            <Link to={`/spreadsheets/edit/${data.id}`} title="Editar">
              <IconButton
                aria-label="Editar"
                size={"sm"}
                colorScheme={"secondary"}
                color={"primary.400"}
              >
                <AiOutlineEdit size={16} />
              </IconButton>
            </Link>
          )}
        {!isDascam &&
          permDelete &&
          (data.status === ExcelStatusEnum.PENDING ||
            data.status === ExcelStatusEnum.CORRECTION) && (
            <IconButton
              aria-label="Deletar"
              title="Excluir"
              size={"sm"}
              colorScheme={"red"}
              onClick={() => {
                if (
                  (data.status === ExcelStatusEnum.PENDING ||
                    data.status === ExcelStatusEnum.CORRECTION) &&
                  data.id
                ) {
                  handleDeleteItemExcel(data.id);
                }
              }}
            >
              <AiOutlineDelete size={16} />
            </IconButton>
          )}
      </HStack>
    );
  }
  function clearData() {
    redirect({});
    setReload(true);
  }
  const handleDeleteItem = (id: number) => {
    dispatch(
      setGlobalMessage({
        message:
          "Deseja realmente excluir este item? \n O item será excluido direto da base de dados",
        type: "MESSAGE",
        buttons: (
          <>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                handleDeleteOperation(id);
                dispatch(clearGlobalMessage());
              }}
            >
              Ok
            </Button>
            <Button
              variant={"outline"}
              color={"red.400"}
              colorScheme={"red"}
              mt={6}
              onClick={() => {
                dispatch(clearGlobalMessage());
              }}
            >
              Cancelar
            </Button>
          </>
        ),
      })
    );
  };
  const handleDeleteOperation = async (id: number) => {
    try {
      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
        })
      );
      await apiClient.operations.delete(id);
      loading.on();
      await apiClient.operations
        .processFilter(filterAPI as any)
        .then((res) => res.process)
        .then((data) => {
          setOperations(() => data);
        })
        .finally(loading.off);
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao enviar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  };
  const handleDeleteItemExcel = (id: number) => {
    dispatch(
      setGlobalMessage({
        message:
          "Deseja realmente excluir este item? \n O item será excluido direto da base de dados",
        type: "MESSAGE",
        buttons: (
          <>
            <Button
              variant={"outline"}
              color={"primary.400"}
              colorScheme={"primary"}
              onClick={() => {
                handleDeleteExcel(id);
                dispatch(clearGlobalMessage());
              }}
            >
              Ok
            </Button>
            <Button
              variant={"outline"}
              color={"red.400"}
              colorScheme={"red"}
              mt={6}
              onClick={() => {
                dispatch(clearGlobalMessage());
              }}
            >
              Cancelar
            </Button>
          </>
        ),
      })
    );
  };
  const handleDeleteExcel = async (id: number) => {
    try {
      dispatch(
        showLoading({
          message: "Carregando",
          isLoading: true,
        })
      );
      await apiClient.operations.deleteSpreadSheet(id);
      loading.on();
      await apiClient.operations
        .processLoadSpreadSheets(filterAPI as any, isDascam)
        .then((res) => res.data)
        .then((res) => res.excel)
        .then((data) => {
          setSpreadsheets(() => data);
        })
        .finally(loading.off);
    } catch (error: any) {
      if (isUnauthorized(error)) {
        history.push("/unauthorized");
      } else {
        dispatch(
          setGlobalMessage({
            message: `Ocorreu um erro ao enviar os dados: ${error}`,
            type: "ERROR",
          })
        );
      }
    } finally {
      dispatch(clearLoading());
    }
  };
  const loadProcess = useCallback(async () => {
    if (filterAPI) {
      loading.on();

      if (!isDascam) {
        let itemsToFind;
        itemsToFind =
          groupList.length !== 0
            ? groupList
            : await apiClient.customers.getCustomersByUser(
                user.company_id ?? user.id!
              );

        if (user.permission_group_company) {
          itemsToFind = itemsToFind.filter((e) =>
            user.permission_group_company?.includes(e.id_syscambio)
          );
        }
        setGroupList(itemsToFind);

        if (!filterAPI.id_syscambio) {
          filterAPI.id_syscambio = itemsToFind.map((e) => e.id_syscambio);
        }
      } else {
        let itemsToFind;
        const filterCompanyList = filterCompany(user) || [];
        const filterGroupList = filterGroup(user) || [];

        itemsToFind = [...filterCompanyList, ...filterGroupList];

        if (itemsToFind && itemsToFind?.length) {
          setGroupList(itemsToFind);

          if (!filterAPI.id_syscambio) {
            filterAPI.id_syscambio = itemsToFind;
          }
        }
      }

      apiClient.operations
        .processFilter(filterAPI as any)
        .then((res) => res.process)
        .then((data) => {
          setOperations(() => data);
        })
        .finally(loading.off);
    }
  }, [filterAPI, isDascam]);
  const loadExcel = useCallback(async () => {
    if (filterAPI) {
      loading.on();

      if (!isDascam) {
        let itemsToFind;
        itemsToFind =
          groupList.length !== 0
            ? groupList
            : await apiClient.customers.getCustomersByUser(
                user.company_id ?? user.id!
              );

        if (user.permission_group_company) {
          itemsToFind = itemsToFind.filter((e) =>
            user.permission_group_company?.includes(e.id_syscambio)
          );
        }
        setGroupList(itemsToFind);

        if (!filterAPI.id_syscambio) {
          filterAPI.id_syscambio = itemsToFind.map((e) => e.id_syscambio);
        }
      } else {
        let itemsToFind;
        const filterCompanyList = filterCompany(user) || [];
        const filterGroupList = filterGroup(user) || [];

        itemsToFind = [...filterCompanyList, ...filterGroupList];

        if (itemsToFind && itemsToFind?.length) {
          setGroupList(itemsToFind);

          if (!filterAPI.id_syscambio) {
            filterAPI.id_syscambio = itemsToFind;
          }
        }
      }

      apiClient.operations
        .processLoadSpreadSheets(filterAPI as any, isDascam)
        .then((res) => res.data)
        .then((res) => res.excel)
        .then((data) => {
          setSpreadsheets(() => data);
        })
        .finally(loading.off);
    }
  }, [filterAPI, isDascam]);

  const styles: Record<string, React.CSSProperties> = {
    container: {
      width: "100%",
      marginTop: 16,
    },

    label: {
      fontSize: 14,
      marginBottom: 6,
    },

    progressWrapper: {
      width: "100%",
      height: 16,
      backgroundColor: "#e5e5e5",
      borderRadius: 6,
      overflow: "hidden",
    },

    progressBar: {
      height: "100%",
      backgroundColor: "#2563eb",
      color: "#fff",
      fontSize: 12,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "width 0.2s ease",
    },
  };

  const [hasLength, setHasLength] = useState(false);

  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
    @keyframes indeterminate {
      0% { margin-left: -40%; }
      50% { margin-left: 40%; }
      100% { margin-left: 100%; }
    }
  `;

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <CardPage
      title={mode === "one" ? "Processos Manuais" : "Planilhas de Processos"}
      _headerRight={
        <VStack spacing={4} align="stretch">
          <Box h="35px" mt={1}>
            {
              <Button
                textColor={mode === "one" ? "white" : "primary.400"}
                size="sm"
                variant={mode === "one" ? "solid" : "outline"}
                colorScheme={"primary"}
                borderRightRadius={"0px"}
                borderColor={mode === "one" ? "primary.400" : "primary"}
                opacity={mode === "one" ? 1 : 0.5}
                onClick={() => {
                  setMode("one");
                  loadProcess();
                  hashData.mode = "one";
                  AppContext.operations = hashData;
                  redirect(hashData);
                }}
              >
                Preenchimento Manual
              </Button>
            }
            {
              <Button
                size="sm"
                variant={mode === "two" ? "solid" : "outline"}
                colorScheme={"primary"}
                borderLeftRadius={"0px"}
                borderColor={mode === "two" ? "primary.400" : "primary"}
                opacity={mode === "two" ? 1 : 0.5}
                onClick={() => {
                  setMode("two");
                  loadExcel();
                  hashData.mode = "two";
                  AppContext.operations = hashData;
                  redirect(hashData);
                }}
              >
                Envio de Planilha
              </Button>
            }
          </Box>
        </VStack>
      }
    >
      <Col px={2} minH={"fill"} w={"100%"}>
        <Collapse in={isLoading}>
          <Progress isIndeterminate colorScheme={"secondary"} h={1} />
        </Collapse>
        {mode === "one" ? (
          <SimpleFormGenerator
            rows={[
              {
                columns: isDascam && hashData?.customer?.group_id ? 5 : 4,
                fields: [
                  {
                    type: "select",
                    label: "Tipo de Contrato",
                    name: "operation_type",
                    options: [
                      {
                        label: () => "Todos",
                        value: undefined,
                      },
                      {
                        label: () => "Remessa",
                        value: "REMESSA",
                      },
                      {
                        label: () => "Importação",
                        value: "IMPORTACAO",
                      },
                      {
                        label: () => "Ingresso",
                        value: "INGRESSO",
                      },
                      {
                        label: () => "Exportação",
                        value: "EXPORTACAO",
                      },
                    ],
                  },
                  !isDascam
                    ? createCustomerSearchPicker(
                        !isDascam ? user.company_id ?? user.id! : 0,
                        user.cad_type === "AUTORIZADO"
                          ? user.permission_group_company ?? []
                          : undefined,
                        {
                          label: `Empresa ${
                            hashData?.customer?.document
                              ? `(${formatCNPJ(hashData?.customer?.document)})`
                              : ""
                          }`,
                          name: "customer",
                          labelKey: "fantasy_name",
                        }
                      )
                    : createClientSearchPicker(
                        {
                          label: `Empresa ${
                            hashData?.customer?.document
                              ? `(${formatCNPJ(hashData?.customer?.document)})`
                              : ""
                          }`,
                          name: "customer",
                          labelKey: "fantasy_name",
                        },
                        undefined,
                        filterCompany(user)
                      ),
                  isDascam && hashData?.customer?.group_id
                    ? createClientForGroupSearchPicker(
                        hashData?.customer?.group_id,
                        {
                          label: `Eps. Grupo ${
                            hashData?.group?.document
                              ? `(${formatCNPJ(hashData?.group?.document)})`
                              : ""
                          }`,
                          name: "group",
                          labelKey: "fantasy_name",
                        },
                        undefined,
                        filterGroup(user)
                      )
                    : undefined,
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                ],
              },
              {
                columns: 4,
                fields: [
                  createCurrencySearchPicker(
                    {
                      label: "Moeda",
                      name: "currency_code",
                      labelKey: "Nome",
                    },
                    currencies
                  ),
                  {
                    type: "select",
                    label: "Status",
                    name: "status",
                    options: [
                      {
                        label: () => "Todos",
                        value: undefined,
                      },
                      {
                        label: () => "Em Analise",
                        value: "SENT",
                      },
                      {
                        label: () => "Rascunho",
                        value: "PENDING",
                      },
                      {
                        label: () => "Em Correção",
                        value: "CORRECTION",
                      },
                      {
                        label: () => "Cancelado",
                        value: "CANCELED",
                      },
                      {
                        label: () => "Aprovado",
                        value: "APPROVAL",
                      },
                    ],
                  },
                  createPayerReceiverSearchPicker(
                    hashData?.customer?.id_syscambio,
                    {
                      readOnly: !hashData?.customer?.id_syscambio,
                      label: "Pagador/Recebedor",
                      name: "payer_receiver",
                      labelKey: "NomeBeneficiario",
                    }
                  ),
                  {
                    type: "custom",
                    label: "custom",
                    name: "custom",
                    custom: (
                      <Row h="40px" mt={6}>
                        {!isDascam && (
                          <Link to={`/operations/create`}>
                            <Button
                              disabled={permCreation}
                              variant={"outline"}
                              color={"green.400"}
                              mr="10px"
                              colorScheme={"green"}
                            >
                              + Inclusão de Processo
                            </Button>
                          </Link>
                        )}
                        {
                          <Button
                            variant={"outline"}
                            color={"red.400"}
                            colorScheme={"red"}
                            mr="10px"
                            onClick={() => {
                              clearData();
                              AppContext.operations = hashData;
                            }}
                          >
                            <FaRegTrashAlt size={20} />
                          </Button>
                        }
                        {
                          <Button
                            variant={"outline"}
                            color={"primary.400"}
                            colorScheme={"primary"}
                            onClick={() => {
                              loadProcess();
                              AppContext.operations = hashData;
                            }}
                          >
                            <FaSearch size={20} />
                          </Button>
                        }
                      </Row>
                    ),
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              const { fantasy_name, document, id_syscambio, group_id } =
                v.customer || {};
              const { CodPagReg, NomeBeneficiario } = v.payer_receiver || {};

              const nextParams: any = { ...v };

              if (v.customer) {
                nextParams.customer = {
                  fantasy_name,
                  document,
                  id_syscambio,
                  group_id,
                };
              }

              if (v.group) {
                nextParams.group = {
                  id_syscambio: v.group.id_syscambio,
                  fantasy_name: v.group.fantasy_name,
                  document: v.group.document,
                };
              }

              if (v.payer_receiver) {
                nextParams.payer_receiver = { CodPagReg, NomeBeneficiario };
              }

              if (v.currency_code) {
                nextParams.currency_code = { ...v.currency_code };
              }

              redirect(nextParams);
            }}
          />
        ) : (
          <SimpleFormGenerator
            rows={[
              {
                columns: isDascam && hashData?.customer?.group_id ? 3 : 2,
                fields: [
                  !isDascam
                    ? createCustomerSearchPicker(
                        !isDascam ? user.company_id ?? user.id! : 0,
                        user.cad_type === "AUTORIZADO"
                          ? user.permission_group_company ?? []
                          : undefined,
                        {
                          label: `Empresa ${
                            hashData?.customer?.document
                              ? `(${formatCNPJ(hashData?.customer?.document)})`
                              : ""
                          }`,
                          name: "customer",
                          labelKey: "fantasy_name",
                        }
                      )
                    : createClientSearchPicker(
                        {
                          label: `Empresa (Cadastrada) ${
                            hashData?.customer?.document
                              ? `(${formatCNPJ(hashData?.customer?.document)})`
                              : ""
                          }`,
                          name: "customer",
                          labelKey: "fantasy_name",
                        },
                        undefined,
                        filterCompany(user)
                      ),
                  isDascam && hashData?.customer?.group_id
                    ? createClientForGroupSearchPicker(
                        hashData?.customer?.group_id,
                        {
                          label: `Eps. Grupo ${
                            hashData?.group?.document
                              ? `(${formatCNPJ(hashData?.group?.document)})`
                              : ""
                          }`,
                          name: "group",
                          labelKey: "fantasy_name",
                        },
                        undefined,
                        filterGroup(user)
                      )
                    : undefined,
                  {
                    type: "select",
                    label: "Status",
                    name: "status",
                    options: [
                      {
                        label: () => "Todos",
                        value: undefined,
                      },
                      {
                        label: () => "Em Analise",
                        value: "SENT",
                      },
                      {
                        label: () => "Rascunho",
                        value: "PENDING",
                      },
                      {
                        label: () => "Em Correção",
                        value: "CORRECTION",
                      },
                      {
                        label: () => "Cancelado",
                        value: "CANCELED",
                      },
                      {
                        label: () => "Aprovado",
                        value: "APPROVAL",
                      },
                      {
                        label: () => "Rejeitado",
                        value: "REJECTED",
                      },
                    ],
                  },
                  {
                    type: "text",
                    label: "ID do Processo",
                    name: "id",
                  },
                ],
              },
              {
                columns: 3,
                fields: [
                  {
                    type: "date",
                    label: "Período",
                    name: "start_date",
                  },
                  {
                    type: "date",
                    label: "até",
                    name: "end_date",
                  },
                  {
                    type: "custom",
                    custom: (
                      <Row h="40px" mt={6}>
                        <Button
                          disabled={isLoading || spreadsheets.length === 0}
                          variant={"outline"}
                          color={"green.400"}
                          colorScheme={"green"}
                          mr="10px"
                          onClick={() => {
                            exportMode2Excel();
                          }}
                        >
                          <RiFileExcel2Line size={25} />
                        </Button>
                        <Button
                          disabled={isLoading || spreadsheetsFiles.length === 0}
                          variant={"outline"}
                          color={"green.600"}
                          colorScheme={"green"}
                          mr="10px"
                          onClick={() => {
                            exportFilesExcel();
                          }}
                        >
                          <FaFileDownload size={25} />
                        </Button>
                        {!isDascam && (
                          <Link to={`/spreadsheets/create`}>
                            <Button
                              disabled={permCreation}
                              variant={"outline"}
                              color={"green.400"}
                              mr="10px"
                              colorScheme={"green"}
                            >
                              + Inclusão de Processo
                            </Button>
                          </Link>
                        )}
                        {
                          <Button
                            variant={"outline"}
                            color={"red.400"}
                            colorScheme={"red"}
                            mr="10px"
                            onClick={() => {
                              clearData();
                              setMode("two");
                              AppContext.operations = hashData;
                            }}
                          >
                            <FaRegTrashAlt size={20} />
                          </Button>
                        }
                        {
                          <Button
                            variant={"outline"}
                            color={"primary.400"}
                            colorScheme={"primary"}
                            onClick={() => {
                              loadExcel();
                              AppContext.operations = hashData;
                            }}
                          >
                            <FaSearch size={20} />
                          </Button>
                        }
                      </Row>
                    ),
                    name: "custom",
                    label: "custom",
                  },
                ],
              },
            ]}
            value={hashData}
            onChange={(v) => {
              const { fantasy_name, document, id_syscambio, group_id } =
                v.customer || {};
              const { CodPagReg, NomeBeneficiario } = v.payer_receiver || {};

              const nextParams: any = { ...v };

              if (v.customer) {
                nextParams.customer = {
                  fantasy_name,
                  document,
                  id_syscambio,
                  group_id,
                };
              }

              if (v.group) {
                nextParams.group = {
                  id_syscambio: v.group.id_syscambio,
                  fantasy_name: v.group.fantasy_name,
                  document: v.group.document,
                };
              }

              if (v.payer_receiver) {
                nextParams.payer_receiver = { CodPagReg, NomeBeneficiario };
              }

              if (v.currency_code) {
                nextParams.currency_code = { ...v.currency_code };
              }

              redirect(nextParams);
            }}
          />
        )}
        <Collapse in={isDownloading}>
          <div style={styles.container}>
            <div style={styles.label}>
              Baixado: {downloadedMB.toFixed(2)} MB
            </div>

            <div style={styles.progressWrapper}>
              <div
                style={{
                  ...styles.progressBar,
                  width: hasLength ? `${downloadedMB}%` : "40%",
                  animation: hasLength
                    ? undefined
                    : "indeterminate 2s infinite",
                }}
              >
                {hasLength ? `${downloadedMB.toFixed(2)}%` : "Processando..."}
              </div>
            </div>
          </div>
        </Collapse>
      </Col>
      <Col id="cont" minH={"60%"} px={2}>
        <Col
          mt={1}
          rounded={"lg"}
          overflow={"auto"}
          border={"1px solid transparent"}
          borderColor={"primary.600"}
        >
          {mode === "one" ? (
            <>
              <DataTable
                noDataComponent=""
                columns={columns}
                data={
                  filterTextExternal
                    ? operations.filter((item) =>
                        filterTextType === 1
                          ? item.id &&
                            item.id?.toString().includes(filterTextExternal)
                          : filterTextType === 2
                          ? item.user?.user_name &&
                            item.user?.user_name
                              .toLowerCase()
                              .includes(filterTextExternal.toLowerCase())
                          : item?.ref_cli &&
                            item?.ref_cli
                              .toLowerCase()
                              .includes(filterTextExternal.toLowerCase())
                      )
                    : operations
                }
                dense={true}
                fixedHeader={true}
                fixedHeaderScrollHeight={`${
                  (document.getElementById("cont")?.clientHeight ?? 0) - 25
                }px`}
                striped={true}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            </>
          ) : (
            /* table show clients */
            <DataTable
              noDataComponent=""
              columns={columnsOperationExcel}
              data={
                filterTextExternal
                  ? spreadsheets.filter((item) =>
                      filterTextType === 1
                        ? item.id &&
                          item.id?.toString().includes(filterTextExternal)
                        : filterTextType === 2
                        ? item.user?.user_name &&
                          item.user?.user_name
                            .toLowerCase()
                            .includes(filterTextExternal.toLowerCase())
                        : item?.client_ref &&
                          item?.client_ref
                            .toLowerCase()
                            .includes(filterTextExternal.toLowerCase())
                    )
                  : spreadsheets
              }
              dense={true}
              fixedHeader={true}
              fixedHeaderScrollHeight={`${
                (document.getElementById("cont")?.clientHeight ?? 0) - 25
              }px`}
              striped={true}
              selectableRows
              onSelectedRowsChange={(data) => {
                setSpreadsheetsFiles(data.selectedRows);
              }}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
            />
          )}
        </Col>
      </Col>

      <Historic
        showModal={showModal}
        handleModal={() => setShowModal(!showModal)}
        operation={operation}
      />
    </CardPage>
  );
};

export default ListOperationsPage;
